import { client } from "../../utils";
import Prismic from "prismic-javascript";

export const fetchResources = filters => dispatch => {
  client
    .query(Prismic.Predicates.at("document.type", "resources"), {
      orderings: "[my.resources.date desc]",
      ...filters
    })
    .then(res => {
      dispatch({
        type: "FETCH_RESOURCES",
        payload: res
      });
    });
};

export const fetchResourcesWithTags = (filters, tags) => dispatch => {
  client
    .query(
      [
        Prismic.Predicates.at("document.type", "resources"),
        Prismic.Predicates.at("document.tags", tags)
      ],
      {
        orderings: "[my.resources.date desc]",
        ...filters
      }
    )
    .then(res => {
      dispatch({
        type: "FETCH_RESOURCES_WITH_TAGS",
        payload: res
      });
    });
};



// WEBPACK FOOTER //
// ./src/store/actions/resourceActions.js